import React, { useContext, useRef, useState } from 'react';


import background2 from '../sections/images/Background2.png'
import background3 from '../sections/images/Background4.png'

import hero from "../sections/images/hero.png"
import { StyleClass } from 'primereact/styleclass';
import { Button } from 'primereact/button';
import { Ripple } from 'primereact/ripple';
import { Divider } from 'primereact/divider';
import { classNames } from 'primereact/utils';
import { Hero } from '../sections/hero';
import { Unified_Platform } from '../sections/unified-platform';
import { Security_Privacy } from '../sections/security-privacy';
import { Why_Clincove } from '../sections/why-clincove';
import { ContactForm } from '../sections/contact-form';
import { Family } from '../sections/family';
import { Investor } from '../sections/investor';



export const InvestorUpdate = () => {

    return (<>

        <Hero />
        <div style={{ backgroundColor: "#F6F9FC", border: "0px solid" }}>
            <Investor />
        </div>

    </>
    )
}